import {normalize} from 'normalizr';
import * as schema from './schemas';
import {actions} from '../actions';

const initialState = {};

export default function questionsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.STEPS.FETCH_FULFILLED: {
      const {step} = action.payload;
      const {
        entities: {questions},
      } = normalize(step, schema.Step);

      return {...state, ...questions};
    }

    case actions.QUESTIONS.FETCH_FULFILLED: {
      const {question} = action.payload;
      const {
        entities: {questions},
      } = normalize(question, schema.Question);

      return {...state, ...questions};
    }

    case actions.PROGRESS.RESET_SERVICE_SELECTION: {
      const {questionHandles} = action.payload;

      return questionHandles.reduce((newState, handle) => {
        if (state[handle]) {
          newState[handle] = {...state[handle]};
        }
        return newState;
      }, {});
    }
  }

  return state;
}
